import { Component, Input, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ContactContainer } from 'src/app/interfaces/contact-container';
import { CNConsultation } from 'src/app/models/cnconsultation';

@ManageType('ContactContentLogoComponent')
@Component({
  selector: 'app-contact-content-logo',
  templateUrl: './contact-content-logo.component.html',
  styleUrls: ['./contact-content-logo.component.scss']
})
export class ContactContentLogoComponent implements OnInit, ContactContainer {

  private contentContact: CNConsultation;

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * ContactContainer interface
   */

  @Input() set contact(theContact: CNConsultation) {
    this.contentContact = theContact;
    console.log('contact', this.contentContact);
  }

  get contact(): CNConsultation {
    return this.contentContact;
  }
}
